import { AdminService } from './../../../_services/admin.service';



import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-grouping-student-index',
  templateUrl: './subscription-grouping-student-index.component.html',
  styleUrls: ['./subscription-grouping-student-index.component.css']
})
export class SubscriptionGroupingStudentIndexComponent implements OnInit {
 dtOptions: DataTables.Settings = {}
 subscriptionGroupingStudentList:any = undefined
  @Input() subscriptionGrouping:any = undefined
  subscriptionGroup:any=undefined

  groupingName:any=undefined
  groupName:any=undefined
  server_subscription_group_id:number=undefined
  loading=false

  constructor(private adminService:AdminService) { }

  ngOnInit(): void {
    this.loading=true

    if(this.subscriptionGrouping){
      this.adminService.getSubscriptionGroupingStudentList(this.subscriptionGrouping.server_subscription_grouping_id).subscribe(
      values=>{
        this.subscriptionGroup=this.subscriptionGrouping['subscriptionGroup']
        this.groupName=this.subscriptionGroup['name']
        this.groupingName=this.subscriptionGrouping['name']
        this.subscriptionGroupingStudentList = values
        this.loading=false
      })
  }
}
subscriptionTypeName(basicStudentInfo:Object){
let subscriptionObject = basicStudentInfo['subscription_object']
if(!this.isDummySubscription(subscriptionObject)){
  return subscriptionObject['subscription_type_name']
}else{
  return ""
}
}
subscriptionStatus(basicStudentInfo:Object){
  let subscriptionObject = basicStudentInfo['subscription_object']
  if(!this.isDummySubscription(subscriptionObject)){
    return subscriptionObject['is_valid']
  }else{
    return ""
  }
  }


isDummySubscription(subscriptionObject:Object){
return subscriptionObject['server_subscription_id']==0
}
}


